import React, { useState } from 'react';

import { Button, CircularProgress } from '@mui/material';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { OIDC_LOGIN_REDIRECT_PATH } from '../../config/apiPaths';
import { getUserUuidHeaders } from '../../utils/httpUtils';
import { getUrls } from '../../utils/url';

const OidcButton = styled(Button)`
    position: relative;
    width: 100%;
    padding: 0.75rem;
    border-radius: 0;
    margin-bottom: 1rem;
    font-size: 16px;
`;

const OidcButtonProgress = styled(CircularProgress)`
    position: absolute;
    right: 14px;
`;

export interface OidcLoginButtonProps {
    oidcId: string;
    oidcTitle: string;
}

const OidcLoginButton: React.FC<OidcLoginButtonProps> = ({ oidcId, oidcTitle }) => {
    const { api } = getUrls();
    const { t } = useTranslation('login');

    const [loading, setLoading] = useState(false);

    const handleLoginRedirect = () => {
        setLoading(true);

        //TODO post to oidc login endpoint and get redirect url
        //get redirect url from response
        const redirectUrlEndpoint = `${api}${OIDC_LOGIN_REDIRECT_PATH(oidcId)}`;
        const localUserUuid = window.localStorage.getItem('user_uuid')
        axios.post(redirectUrlEndpoint,
            {},
            {
                headers: getUserUuidHeaders(localUserUuid!)
            })
            .then(response => {
                const redirectUrl = response.data.url;
                window.location.href = redirectUrl;
            })
            .catch(error => {
                console.error('Error during OIDC login redirect:', error);
                setLoading(false);
            });
    };

    return (
        <OidcButton disabled={loading} variant="outlined" onClick={() => handleLoginRedirect()}>
            {oidcTitle}
            {loading && <OidcButtonProgress size={30} />}
        </OidcButton>
    );
};

export default OidcLoginButton;
